import * as z from 'zod'

export const ExternalUrlSchema = z.object({
	url: z.string().nonempty(),
	title: z.string().nonempty()
})

export type ExternalUrlType = z.TypeOf<typeof ExternalUrlSchema>